import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  return <div className="w-full px-6 py-20 bg-gradient-to-b from-slate-950 via-slate-900/50 to-transparent" data-id="element-238">
      <div className="max-w-4xl mx-auto" data-id="element-239">
        <div className="bg-gradient-to-br from-purple-900/30 via-cyan-900/20 to-purple-900/30 border-2 border-cyan-500/50 rounded-2xl p-8 md:p-12 space-y-6" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-241">
            What You'll Get in Your Meeting With the Master
          </h2>
          <p className="text-xl text-center text-gray-300 font-light" data-id="element-242">
            In this single, powerful session, you will get what years of chasing
            symptoms has never provided:{' '}
            <span className="text-cyan-400 font-bold" data-id="element-243">clarity</span>.
          </p>
          <div className="space-y-4 text-lg text-gray-300 font-light" data-id="element-244">
            <div className="flex items-start gap-3" data-id="element-245">
              <CheckCircleIcon className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" data-id="element-246" />
              <p data-id="element-247">
                Brenden or Dr. Ali will listen to your situation and analyze the
                root cause of what's holding you back
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-248">
              <CheckCircleIcon className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" data-id="element-249" />
              <p data-id="element-250">Get the step-by-step breakdown of what you need to do next</p>
            </div>
            <div className="flex items-start gap-3" data-id="element-251">
              <CheckCircleIcon className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" data-id="element-252" />
              <p data-id="element-253">
                They will tell you exactly what to do, potentially including
                what to take, how to take it, when to take it, how much to take,
                where to get it and more
              </p>
            </div>
          </div>
          <p className="text-xl font-semibold text-center text-white pt-4" data-id="element-254">
            After this process you will understand EXACTLY what needs to happen
            for you to best achieve your health, longevity & performance goals.
          </p>
        </div>
      </div>
    </div>;
}